(function(angular, _) {
    function filterByPredicate($filter) {
        return function(list, _keyword, predicates = []) {
            const keyword = _.chain(_keyword)
                             .toString()
                             .trim()
                             .toLower()
                             .value();

            if (!keyword) {
                return list;
            }

            if (!predicates.length || predicates === '*') {
                return $filter('filter')(list, keyword);
            }

            return list.filter((item) => {
                return !_.chain(item)
                    .pick(predicates)
                    .map((value) => {
                        return _.chain(value)
                                .toString()
                                .toLower()
                                .value()
                                .indexOf(`${keyword}`) > -1;
                    })
                    .compact()
                    .size()
                    .eq(0)
                    .value();
            });
        };
    }

    filterByPredicate.$inject = ['$filter'];

    angular.module('wtUi.wtFilters').filter('filterByPredicate', filterByPredicate);
})(window.angular, window._);
